export default {
  Draft: 'draft',
  PendingApproval: 'pendingApproval',
  Open: 'open',
  Cancelled: 'cancelled',
  Closed: 'closed',
}
